module.exports = __webpack_public_path__ + "static/img/智能报账3.b9822e04.png";